import { render, staticRenderFns } from "./Salary.vue?vue&type=template&id=b2a5e3e6&scoped=true"
import script from "./Salary.vue?vue&type=script&lang=js"
export * from "./Salary.vue?vue&type=script&lang=js"
import style0 from "./Salary.vue?vue&type=style&index=0&id=b2a5e3e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a5e3e6",
  null
  
)

export default component.exports